export const getDecimalPrecision = (value: number | string) => {
    const inputs: string[] = `${value}`.split('.');

    if (inputs[1]) {
        return inputs[1].length;
    }

    return 0;
};
